/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddRentLineDto,
  BulkDeleteRentRequest,
  CreateRentDto,
  CreatedRentResponse,
  ReadRentsQueryDto,
  RemoveEquipmentDto,
  RentResponse,
  UpdateEquipmentPaymentValue,
  UpdateRentCustomerOrAddressDto,
  UpdateRentDateDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Rents<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags rents
   * @name CreateRent
   * @request POST:/rents
   * @secure
   */
  createRent = (data: CreateRentDto, params: RequestParams = {}) =>
    this.request<CreatedRentResponse, any>({
      path: `/rents`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name StartRent
   * @request POST:/rents/{id}/startRent
   * @secure
   */
  startRent = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/rents/${id}/startRent`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name EndRent
   * @request POST:/rents/{id}/endRent
   * @secure
   */
  endRent = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/rents/${id}/endRent`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name PayRent
   * @request POST:/rents/{id}/payRent
   * @secure
   */
  payRent = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/rents/${id}/payRent`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name UnpayRent
   * @request POST:/rents/{id}/unpayRent
   * @secure
   */
  unpayRent = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/rents/${id}/unpayRent`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name FindRents
   * @request POST:/rents/read-rents
   * @secure
   */
  findRents = (data: ReadRentsQueryDto, params: RequestParams = {}) =>
    this.request<RentResponse[], any>({
      path: `/rents/read-rents`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name GetCustomerRentsReport
   * @request POST:/rents/get-customer-rents-report
   * @secure
   */
  getCustomerRentsReport = (
    data: ReadRentsQueryDto,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/rents/get-customer-rents-report`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name GetAllCustomerRentsOverviewReport
   * @request POST:/rents/get-all-customers-rents-overview-report
   * @secure
   */
  getAllCustomerRentsOverviewReport = (
    data: ReadRentsQueryDto,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/rents/get-all-customers-rents-overview-report`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name GetMonthlyReport
   * @request POST:/rents/get-customers-montly-report
   * @secure
   */
  getMonthlyReport = (data: ReadRentsQueryDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/rents/get-customers-montly-report`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name ReserveRent
   * @request POST:/rents/{id}/reserveRent
   * @secure
   */
  reserveRent = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/rents/${id}/reserveRent`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name AddEquipment
   * @request POST:/rents/{id}/addEquipment
   * @secure
   */
  addEquipment = (
    id: string,
    data: AddRentLineDto,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/rents/${id}/addEquipment`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name RemoveEquipment
   * @request POST:/rents/{id}/removeEquipment
   * @secure
   */
  removeEquipment = (
    id: string,
    data: RemoveEquipmentDto,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/rents/${id}/removeEquipment`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name UpdateRentDate
   * @request POST:/rents/{id}/updateDate
   * @secure
   */
  updateRentDate = (
    id: string,
    data: UpdateRentDateDto,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/rents/${id}/updateDate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name UpdateRentCustomerOrAddress
   * @request POST:/rents/{id}/update-customer-or-address
   * @secure
   */
  updateRentCustomerOrAddress = (
    id: string,
    data: UpdateRentCustomerOrAddressDto,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/rents/${id}/update-customer-or-address`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name UpdateEquipmentPaymentValue
   * @request POST:/rents/{id}/updateEquipmentPaymentValue
   * @secure
   */
  updateEquipmentPaymentValue = (
    id: string,
    data: UpdateEquipmentPaymentValue,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/rents/${id}/updateEquipmentPaymentValue`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name CancelRent
   * @request POST:/rents/{id}/cancel
   * @secure
   */
  cancelRent = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/rents/${id}/cancel`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rents
   * @name BulkDeleteRent
   * @request POST:/rents/bulk-delete
   * @secure
   */
  bulkDeleteRent = (data: BulkDeleteRentRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/rents/bulk-delete`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
